// @ts-nocheck
import React, { useEffect, useMemo, useCallback } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  gqlGetCpSubsubgroup,
  gqlAddCpSubsubgroup,
  gqlUpdateCpSubsubgroup,
  gqlDeleteCpSubsubgroup,
} from './graphql';
import { useParams, useHistory, useLocation, generatePath } from 'react-router-dom';

import * as Yup from 'yup';
import * as Lo from 'lodash';
import { getRouteByName } from 'app/routes';
import {
  FieldInput,
  FormCard,
  FormCol,
  FormRow,
  isNumeric,
  promiseModalDialog,
  toastSuccess,
  UserTooltip,
  useWhyDidYouUpdate,
  YupNumeric,
  YupStringReq,
} from 'motion-components';
import { useHandleError } from 'shared-pages/services';
import { FieldSelectGroup, FieldSelectSubGroup } from 'shared-pages/components';

const formShape = {
  name: YupStringReq,
  subgroupId: YupNumeric,
  cpSubgroup: null,
};

const validationSchema = Yup.object().shape(formShape);
const pickProperties = (values) => Lo.pick(values, Lo.keys(formShape));
type FormValuesType = Yup.InferType<typeof validationSchema>;

export const CpSubSubGroupPage = () => {
  const { handleGraphqlError } = useHandleError('cpsubsubgroup');
  const history = useHistory();
  const location = useLocation();
  const { id, selected, selectedSub } = useParams<{
    id: string;
    selected: string;
    selectedSub: string;
  }>();

  const idNum = isNumeric(id) ? parseInt(id) : -1;
  const isNew = idNum < 0;

  const newRecord = useMemo<FormValuesType>(
    () =>
      ({
        id: -1,
        name: null,
        subgroupId: parseInt(selectedSub),
        cpSubgroup: {
          groupId: parseInt(selected),
        },
      } as FormValuesType),
    [selected, selectedSub],
  );

  const [addRecord] = useMutation(gqlAddCpSubsubgroup);
  const [updateRecord] = useMutation(gqlUpdateCpSubsubgroup);
  const [deleteRecord] = useMutation(gqlDeleteCpSubsubgroup);
  const [get, { data: rawData, error, refetch }] = useLazyQuery(gqlGetCpSubsubgroup);
  const data = isNew ? newRecord : rawData ? rawData.getCpSubsubgroupById : undefined;

  useWhyDidYouUpdate('CpSubSubGroupPage', { data, selected, selectedSub });

  /* fetch data */
  useEffect(() => {
    if (!isNew) {
      get({ variables: { id: idNum } });
    }
  }, [get, id, idNum, isNew]);

  /**
   * * ΑΠΟΘΗΚΕΥΣΗ - UPDATE/CREATE
   */
  const handleSubmit = (values: FormValuesType, actions) => {
    actions.setSubmitting(false);
    delete values.cpSubgroup;

    // Αν είναι νέα εγγραφή τοτε γράφω όλα τα πεδία
    if (isNew) {
      console.log('[CpSubsubgroup] New:', values);
      addRecord({ variables: { data: { ...values } } })
        .then((d) => {
          toastSuccess(`Επιτυχής Προσθήκη Εγγραφής [${d.data.addCpSubsubgroup.id}]`);
          handleReturn();
        })
        .catch((error) => {
          handleGraphqlError('mutation-add', error);
        });
    } else {
      // Αν είναι update εγγραφής τοτε γράφω μονο τα αλλαγμένα πεδία
      console.log('[CpSubsubgroup] Update:', values);
      updateRecord({ variables: { data: { ...values, id: idNum } } })
        .then((d) => {
          toastSuccess(`Επιτυχής Ενημέρωση Εγγραφής [${d.data.updateCpSubsubgroup.id}]`);
          refetch();
        })
        .catch((error) => {
          handleGraphqlError('mutation-update', error);
        });
    }
  };

  /**
   * *  DELETE
   */
  const handleDelete = useCallback(async () => {
    const res = await promiseModalDialog({
      title: 'Διαγραφή Εγγραφής',
      text: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την Εγγραφή;',
    });
    if (res) {
      deleteRecord({ variables: { id: idNum } })
        .then(() => handleReturn())
        .catch((error) => {
          handleGraphqlError('mutation-delete', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteRecord, idNum]);
  // Handler να πάει στην πίσω σελίδα
  const handleReturn = useCallback(() => {
    history.push(generatePath(getRouteByName('CpGroups')), { ...location.state });
  }, [history, location.state]);

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  } else {
    return (
      <FormCard
        isNew={isNew}
        title={isNew ? 'Υπο-υποκατηγορία: Εισαγωγή Νέας' : `Υπο-υποκατηγορία: ${data?.name}`}
        onSubmit={handleSubmit}
        onReturn={null}
        onDelete={handleDelete}
        permitDelete={true}
        initialValues={pickProperties(data)}
        validationSchema={validationSchema}
        enableReinitialize
        idx={idNum}
      >
        <FormRow>
          <FieldSelectGroup
            name={'cpSubgroup.groupId'}
            as={FormCol}
            disabled={true}
            defaultValues={data ? data.cpSubgroup : null}
          ></FieldSelectGroup>
        </FormRow>
        <FormRow>
          <FieldSelectSubGroup
            as={FormCol}
            disabled={true}
            defaultValues={data}
          ></FieldSelectSubGroup>
        </FormRow>
        <FormRow>
          <SubSubGroupName />
        </FormRow>
        <div className="float-end">{data && !isNew && <UserTooltip data={data} />}</div>
      </FormCard>
    );
  }
};

// ---------------------- DATA FIELDS -----------------------
const SubSubGroupName = () => {
  return (
    <FieldInput
      as={FormCol}
      label="Υπο-υποκατηγορία"
      name="name"
      placeholder="- υπο-υποκατηγορία -"
    />
  );
};

